<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M14.1 12.5001C17.2 12.5001 19.8 10.0001 19.8 6.80007C19.8 3.70007 17.3 1.10007 14.1 1.10007C10.9
    1.00007 8.30005 3.50007 8.30005 6.70007C8.30005 9.90007 10.9 12.5001 14.1 12.5001Z"
    fill="#748097"
  />
  <path
    d="M21.5 14.6001C17 14.6001 13.2 18.3001 13.2 22.9001C13.2 27.5001 16.9 31.2001 21.5 31.2001C26.1
    31.2001 29.7999 27.5001 29.7999 22.9001C29.7999 18.1001 26.1 14.6001 21.5 14.6001ZM21.5 30.0001V28.0001C18.6
    28.0001 16.3 25.7001 16.3 22.8001C16.3 21.8001 16.6 20.9001 17.1 20.0001L18.1 21.0001C17.8 21.6001 17.7 22.1001
    17.7 22.8001C17.7 25.0001 19.5 26.7001 21.6 26.7001V24.8001L24.2 27.4001L21.5 30.0001ZM25.9 25.6001L24.9 24.6001C25.2
    24.0001 25.3 23.5001 25.3 22.8001C25.3 20.6001 23.5 18.9001 21.4 18.9001V20.8001L18.8 18.2001L21.4 15.6001V17.5001C24.3
    17.5001 26.6 19.8001 26.6 22.7001C26.6 23.8001 26.3 24.7001 25.9 25.6001Z"
    fill="#009DD6"
  />
  <path
    d="M11.3001 22.7C11.3001 19.3 13.1001 16.4 15.8001 14.7H9.8001C6.0001 14.7 3.1001 17.7 3.1001 21.4V24C3.1001 24.6
    3.5001 25 4.1001 25H11.7001C11.4001 24.3 11.3001 23.5 11.3001 22.7Z"
    fill="#748097"
  />
</svg>
